import * as actionTypes from "../../constants/actionTypes";
import * as batchStatuses from "../../constants/batchStatuses";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as reducerHelper from "../../helpers/reducerHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_FORMULA_META_AND_DISPENSE:
            if (!responseHelper.isGetFormulaMetaData2FormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let quickTint = state.rcc.dispensingFormula;

            if (quickTint === null || quickTint.formula === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.RELOAD_DISPENSING_FORMULA_META_DATA,
                    payload: {
                        priceList: response.data.priceList === null ? [] : response.data.priceList,
                        printData: response.data.printData,
                        tmcData: response.data.tmcData,
                        infoData: response.data.infoData
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_START_DISPENSE_FORMULA,
                        params: {
                            name: quickTint.formula.name,
                            displayName: quickTint.formula.name,
                            formula: quickTint.formula.getColorantVolumes(),
                            numCans: 1,
                            numCansDone: 0,
                            customCan: false,
                            details: null,
                            displayDetails: null,
                            shelf: [-1, 0, -1],
                            punch: 0,
                            info: {
                                formulaName: null,
                                colorantList: reducerHelper.processColorantsForTmc(quickTint.formula.colorantList),
                                package: null,
                                fandeckName: null,
                                productName: null,
                                base: null
                            },
                            tmcData: response.data.tmcData,
                            infoData: response.data.infoData,
                            meta: {
                                colorStatsId: null,
                                tabId: tabId,
                                quickTint: true,
                                orderId: null,
                                automaticPrint: false,
                                printBeforeDispensing: false,
                                printPagesBeforeDispensing: false,
                                printAfterDispensing: false,
                                printPagesAfterDispensing: false
                            }
                        }
                    },
                    method: handlers.MACHINE_START_DISPENSE_FORMULA,
                    tabId: tabId,
                    safe: true
                }
            ];
        case handlers.ADD_DISPENSED_PACKAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        case handlers.FINISH_DISPENSED_PACKAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let toDispenseTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.TO_DISPENSE_TAB);

            let packageActions = [
                {
                    type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                    payload: {
                        tabId: toDispenseTab !== undefined ? toDispenseTab.id : 0
                    }
                }
            ];

            if (state.toDispense.activeOrder !== null) {
                packageActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ORDER_DETAIL,
                        params: {
                            id: state.toDispense.activeOrder.id
                        }
                    },
                    method: handlers.TO_DISPENSE_GET_DETAIL,
                    tabId: 0
                });
            }

            return packageActions;
        case handlers.ADD_AND_FINISH_ALL_DISPENSED_PACKAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let finishAllActions = [messageHelper.getSuccessMessageAction("flashMessage.savedFormulaToHistory")];

            let statisticsTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.STATISTICS_TAB);

            if (statisticsTab !== undefined) {
                finishAllActions.push({
                    type: actionTypes.STATISTICS_LIST_UPDATE,
                    payload: {
                        tabId: statisticsTab.id
                    }
                });
            }

            let ordersTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.TO_DISPENSE_TAB);

            if (ordersTab !== undefined) {
                finishAllActions.push({
                    type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                    payload: {
                        tabId: ordersTab.id
                    }
                });
            }

            return finishAllActions;
        case handlers.GET_PACKAGES_FOR_COLORANT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PACKAGES_FOR_COLORANT,
                    payload: {
                        colorantPackages: response.data
                    }
                }
            ];
        case handlers.GET_PACKAGES_FOR_COLORANT_WITH_IMAGE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (Array.isArray(response.data) && response.data.length > 0) {
                return [
                    {
                        type: actionTypes.SAVE_PACKAGES_FOR_COLORANT,
                        payload: {
                            colorantPackages: response.data
                        }
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_COLORANT_PACKAGE_IMAGE,
                            params: {
                                colorantPackageId: response.data[0].id,
                                online: state.settings.imagesSource === settings.SOURCE_ONLINE
                            }
                        },
                        method: handlers.GET_COLORANT_PACKAGE_IMAGE,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_PACKAGES_FOR_COLORANT,
                    payload: {
                        colorantPackages: response.data
                    }
                }
            ];
        case handlers.GET_BATCHES_BY_COLORANT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_BATCHES_BY_COLORANT,
                    payload: {
                        data: response.data,
                        colorantList: state.rcc.colorantList
                    }
                }
            ];
        case handlers.GET_ALL_COLORANT_BATCHES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            const colorantBatchNumbers = modelHelper.mapBatchNumbersToObjects(response.data);
            const colorantInCanisterBatchNumbers = modelHelper.mapCanisterBatchNumbersToObjects(
                state.machine.allBatchNumbersList,
                state.rcc.canisterList
            );

            const invalidBatches = [];

            let match;
            for (let colorantId of Object.keys(colorantInCanisterBatchNumbers)) {
                for (const batch of colorantInCanisterBatchNumbers[colorantId]) {
                    if (colorantBatchNumbers && colorantBatchNumbers[colorantId] !== undefined) {
                        match = colorantBatchNumbers[colorantId].find(
                            (colorantBatchNumber) => colorantBatchNumber.batchNumber === batch.batchNumber
                        );
                        if (match && match.statusId !== batchStatuses.BATCH_STATUS_VALID) {
                            invalidBatches.push(match);
                        }
                    }
                }
            }

            if (invalidBatches.length === 0) {
                return [];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: 0,
                        type: componentTypes.INVALID_BATCH_NUMBERS_MODAL,
                        params: {
                            invalidBatches: invalidBatches
                        }
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
